import React from 'react';

function AmericanExpressIcon() {
  return (
    <svg width="59" height="22" viewBox="0 0 59 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2817 21.6011V12.424H20.9431L21.9796 13.783L23.0505 12.424H58.1187V20.9682C58.1187 20.9682 57.2016 21.5919 56.1409 21.6011H36.7229L35.5543 20.1545V21.6011H31.7246V19.1316C31.7246 19.1316 31.2014 19.4764 30.0705 19.4764H28.7669V21.6011H22.9685L21.9334 20.2129L20.8825 21.6011H11.2817Z"
        fill="#016FD0"
      />
      <path
        d="M0 5.50737L2.17867 0.398941H5.94645L7.18287 3.26048V0.398941H11.8666L12.6026 2.46717L13.3162 0.398941H34.3411V1.43871C34.3411 1.43871 35.4464 0.398941 37.2628 0.398941L44.0846 0.422918L45.2997 3.247V0.398941H49.2193L50.298 2.02115V0.398941H54.2536V9.57604H50.298L49.2642 7.94858V9.57604H43.5055L42.9264 8.1294H41.3783L40.8086 9.57604H36.9032C35.3402 9.57604 34.3411 8.5575 34.3411 8.5575V9.57604H28.4528L27.2841 8.1294V9.57604H5.38827L4.80955 8.1294H3.26636L2.69173 9.57604H0V5.50737Z"
        fill="#016FD0"
      />
      <path
        d="M2.94831 1.53001L0.00976562 8.40234H1.92291L2.46511 7.02618H5.61717L6.15655 8.40234H8.11184L5.1761 1.53001H2.94831ZM4.03552 3.12941L4.99631 5.53417H3.07192L4.03552 3.12941Z"
        fill="white"
      />
      <path
        d="M8.31396 8.4007V1.52838L11.0327 1.53854L12.6139 5.96938L14.1573 1.52838H16.8543V8.4007H15.1462V3.33689L13.3356 8.4007H11.8377L10.022 3.33689V8.4007H8.31396Z"
        fill="white"
      />
      <path
        d="M18.0244 8.40077V1.52838H23.5982V3.06563H19.7505V4.24116H23.5083V5.68798H19.7505V6.90874H23.5982V8.40077H18.0244Z"
        fill="white"
      />
      <path
        d="M24.5859 1.53001V8.4024H26.294V5.96089H27.0132L29.0612 8.4024H31.1486L28.9011 5.87047C29.8235 5.79218 30.7749 4.99588 30.7749 3.75959C30.7749 2.3134 29.6464 1.53001 28.387 1.53001H24.5859ZM26.294 3.06726H28.2465C28.7149 3.06726 29.0556 3.43578 29.0556 3.79067C29.0556 4.24724 28.6142 4.51408 28.2718 4.51408H26.294V3.06726Z"
        fill="white"
      />
      <path d="M33.2182 8.40077H31.4741V1.52838H33.2182V8.40077Z" fill="white" />
      <path
        d="M37.3536 8.40077H36.9771C35.1557 8.40077 34.0498 6.95735 34.0498 4.99283C34.0498 2.97979 35.1433 1.52838 37.4435 1.52838H39.3314V3.15605H37.3745C36.4407 3.15605 35.7804 3.88902 35.7804 5.00979C35.7804 6.34071 36.5355 6.8997 37.6233 6.8997H38.0728L37.3536 8.40077Z"
        fill="white"
      />
      <path
        d="M41.0714 1.53001L38.1328 8.40234H40.046L40.5882 7.02618H43.7402L44.2796 8.40234H46.2349L43.2991 1.53001H41.0714ZM42.1586 3.12941L43.1194 5.53417H41.195L42.1586 3.12941Z"
        fill="white"
      />
      <path
        d="M46.4326 8.40077V1.52838H48.6042L51.3771 5.84623V1.52838H53.0851V8.40077H50.9838L48.1407 3.96989V8.40077H46.4326Z"
        fill="white"
      />
      <path
        d="M12.4512 20.4266V13.5543H18.0249V15.0915H14.1772V16.267H17.935V17.7139H14.1772V18.9346H18.0249V20.4266H12.4512Z"
        fill="white"
      />
      <path
        d="M39.7612 20.4266V13.5543H45.335V15.0915H41.4873V16.267H45.2271V17.7139H41.4873V18.9346H45.335V20.4266H39.7612Z"
        fill="white"
      />
      <path
        d="M18.2414 20.4266L20.9552 17.0328L18.1768 13.5543H20.3287L21.9834 15.7047L23.6437 13.5543H25.7113L22.9695 16.9904L25.6883 20.4266H23.5367L21.93 18.3101L20.3624 20.4266H18.2414Z"
        fill="white"
      />
      <path
        d="M25.8896 13.5551V20.4275H27.6427V18.2572H29.4407C30.962 18.2572 32.1152 17.4454 32.1152 15.8666C32.1152 14.5587 31.2107 13.5551 29.6626 13.5551H25.8896ZM27.6427 15.1093H29.5362C30.0277 15.1093 30.379 15.4123 30.379 15.9005C30.379 16.3592 30.0294 16.6917 29.5306 16.6917H27.6427V15.1093Z"
        fill="white"
      />
      <path
        d="M32.8579 13.5543V20.4266H34.566V17.9851H35.2852L37.3332 20.4266H39.4205L37.1731 17.8947C38.0954 17.8164 39.0469 17.0201 39.0469 15.7838C39.0469 14.3376 37.9184 13.5543 36.659 13.5543H32.8579ZM34.566 15.0915H36.5185C36.9869 15.0915 37.3276 15.46 37.3276 15.8149C37.3276 16.2715 36.8861 16.5383 36.5438 16.5383H34.566V15.0915Z"
        fill="white"
      />
      <path
        d="M46.127 20.4266V18.9346H49.5455C50.0513 18.9346 50.2703 18.6597 50.2703 18.3582C50.2703 18.0692 50.0519 17.7772 49.5455 17.7772H48.0007C46.658 17.7772 45.9102 16.9543 45.9102 15.7188C45.9102 14.6169 46.595 13.5543 48.5903 13.5543H51.9165L51.1973 15.1005H48.3206C47.7707 15.1005 47.6014 15.3908 47.6014 15.668C47.6014 15.9529 47.8106 16.267 48.2307 16.267H49.8489C51.3457 16.267 51.9952 17.1211 51.9952 18.2395C51.9952 19.4418 51.2714 20.4266 49.7674 20.4266H46.127Z"
        fill="white"
      />
      <path
        d="M52.3946 20.4266V18.9346H55.813C56.3188 18.9346 56.5378 18.6597 56.5378 18.3582C56.5378 18.0692 56.3195 17.7772 55.813 17.7772H54.2683C52.9255 17.7772 52.1777 16.9543 52.1777 15.7188C52.1777 14.6169 52.8625 13.5543 54.8579 13.5543H58.1162L57.4649 15.1005H54.5882C54.0382 15.1005 53.869 15.3908 53.869 15.668C53.869 15.9529 54.0781 16.267 54.4983 16.267H56.1164C57.6133 16.267 58.2628 17.1211 58.2628 18.2395C58.2628 19.4418 57.539 20.4266 56.0349 20.4266H52.3946Z"
        fill="white"
      />
    </svg>
  );
}

export default AmericanExpressIcon;
